import { forwardRef, useId } from 'react';
import type { SwitchProps } from './Switch.types';
import './Switch.scss';

const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch(
  { label, description, id, className, disabled, ...rest },
  ref,
) {
  const autoId = useId();
  const sId = id || `switch-${autoId}`;
  return (
    <label
      htmlFor={sId}
      className={['switch', disabled ? 'switch--disabled' : '', className || ''].filter(Boolean).join(' ')}
    >
      <span className="switch__control">
        <input ref={ref} id={sId} type="checkbox" role="switch" className="switch__native" disabled={disabled} {...rest} />
        <span className="switch__track" aria-hidden="true">
          <span className="switch__thumb" />
        </span>
      </span>
      {label || description ? (
        <span className="switch__text">
          {label ? <span className="switch__label">{label}</span> : null}
          {description ? <span className="switch__description">{description}</span> : null}
        </span>
      ) : null}
    </label>
  );
});

export default Switch;
